import { spaceRegular } from '@ui/styles/spaces';

export const buttonStyle = {
    alignSelf : 'center' as 'center',
    margin    : `${spaceRegular}px auto 0 auto`,
};

export default buttonStyle;
